<template>
    <div id="Agenda">
        <div id="AgendaButton">
            <!-- svg backgrounds -->
            <img class="bg-button" src="@/assets/img/ui/agenda-button-bg.svg" />
            <img
                class="bg-now-and-next"
                src="@/assets/img/ui/agenda-nextup-bg.svg"
            />

            <div v-if="!todayHasEvent" class="no-event">
                <b> The event has been held. </b>
                <br />You can watch recordings of the live-streams
            </div>

            <div
                class="now-and-next"
                @click="timeTableOpen = !timeTableOpen"
                v-if="todayHasEvent"
            >
                <div class="now" v-if="currentActivity">
                    <span class="label">NOW</span>
                    <span class="info" v-html="currentActivityString"></span>
                </div>

                <div class="next" v-if="nextActivity">
                    <span class="label">NEXT</span>
                    <span class="info" v-html="nextActivityString"></span>
                </div>
            </div>

            <button
                class="agenda"
                @click="timeTableOpen = !timeTableOpen"
                :class="{ active: timeTableOpen, disabled: !todayHasEvent }"
            >
                <span> AGENDA </span>
                <img src="@/assets/img/ui/arrow-down.svg" />
            </button>
        </div>

        <!-- for outside click to hide timetable -->
        <div
            class="timetable-background"
            v-show="timeTableOpen"
            @click="timeTableOpen = false"
        ></div>

        <!-- moving to scene.. overlay -->
        <article class="moving-overlay" :class="{ active: isMovingUser }">
            <img src="@/assets/img/ui/icon-arrow-cycle.svg" />
            Moving to the correct livestream...
        </article>

        <!-- timetable -->
        <TimeTable :active="timeTableOpen" :items="timeTableItems"></TimeTable>

        <!-- Reminder -->
        <Reminder
            :active="showReminder"
            :item="reminderActivity"
            @snooze="closeReminder()"
        ></Reminder>
    </div>
</template>
<script>
const moment = require("moment");

import TimeTable from "./TimeTable.vue";
import Reminder from "./Reminder.vue";

export default {
    components: {
        TimeTable,
        Reminder,
    },

    data() {
        return {
            todayHasEvent: false,
            timeTableOpen: false,
            timeTableItems: [],
            timeCheckInterval: null,
            currentActivity: null,
            nextActivity: null,

            // reminder
            firstReminderMinutesBefore: 5,
            secondReminderMinutesBefore: 2,
            showReminder: false,
            reminderActivity: null,
            snooze: 0,
            isMovingUser: false,
        };
    },

    mounted() {
        // always start on homepage (no direct links)
        //if (!app.api.LocalDataStore.get("check-in"))
        //  app.api.PageManager.navigateToHomePage();

        // get todays event
        this.timeTableItems = this.getTodaysTimeTableItems();

        if (this.timeTableItems.length == 0) {
            console.log("NO EVENT TODAY!");
        } else {
            this.todayHasEvent = true;

            // set dates to match event date (umbraco keeps old date, though its only time given)
            this.timeTableItems = this.updateEventDates(this.timeTableItems);

            // ensure cronologi
            this.timeTableItems = this.orderByStartTime(this.timeTableItems);

            // add pretty times once for all
            this.timeTableItems.forEach((item) => {
                item.startTimeString = new Date(
                    item.startTime
                ).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                });
                item.endTimeString = new Date(item.endTime).toLocaleTimeString(
                    [],
                    { hour: "2-digit", minute: "2-digit", hour12: false }
                );
            });

            // Set up the interval to check time every X seconds
            this.timeCheckInterval = setInterval(this.checkTime, 5000);
            this.checkTime();
        }
    },

    methods: {
        getTodaysTimeTableItems() {
            // get todays events timetable items
            var events =
                app.api.PageManager.getCustomComponentFromType("events");
            if (events && events.children.length > 0) {
                // compare only date - not time
                var currentDate = new Date().toDateString();
                for (const event of events.children) {
                    var eventDate = new Date(
                        event.data.eventDate
                    ).toDateString();
                    if (eventDate === currentDate) {
                        return event.data.timeTable;
                    }
                }
            }
            return [];
        },

        updateEventDates(items) {
            return items.map((event) => {
                const startTime = new Date(event.startTime);
                const endTime = new Date(event.endTime);

                const newStart = new Date();
                const newEnd = new Date();

                // Set the time part to the original event times
                newStart.setUTCHours(
                    startTime.getUTCHours(),
                    startTime.getUTCMinutes(),
                    startTime.getUTCSeconds()
                );
                newEnd.setUTCHours(
                    endTime.getUTCHours(),
                    endTime.getUTCMinutes(),
                    endTime.getUTCSeconds()
                );

                event.startTime = newStart.toISOString();
                event.endTime = newEnd.toISOString();

                return event;
            });
        },

        orderByStartTime(items) {
            return items.sort(
                (a, b) => new Date(a.startTime) - new Date(b.startTime)
            );
        },

        checkTime() {
            let now = moment();

            // find current sceneID
            // let currentRoute = app.api.PageManager.getPage(this.$route.path);
            // let currentSceneID = (currentRoute) ? currentRoute.data.id : 0;

            this.timeTableItems.forEach((item, i) => {
                let startTime = moment(item.startTime);
                let endTime = moment(item.endTime);

                // mark active items
                if (now.isAfter(startTime) && now.isBefore(endTime)) {
                    // for timetable use
                    item.active = true;

                    // for agenda use
                    // NOTE : tjek for om check-in er taget, ellers skal den laves først
                    // iFrame component skal have prop som bliver sat i session storage

                    if (this.currentActivity != item) {
                        // shift activity!
                        this.currentActivity = item;
                        this.snooze = 0;
                        this.showReminder = false;

                        // remember pending content
                        this.$store.commit(
                            "setPendingContentId",
                            item.contentOnClosed
                        );

                        // is new items content already open? (like a livestream that continues)
                        let openContent =
                            app.api.PageManager.getOpenContentComponents();
                        let contentAlreadyOpen = openContent.some(
                            (oc) => oc.id === item.contentId
                        );

                        console.log(
                            "Content Already Open: ",
                            contentAlreadyOpen
                        );

                        // force user to route (if reminder or content id)
                        // some live streams doesn't not have a reminder - but still need to be forced open on page load
                        if (
                            item.useReminder ||
                            (item.contentId != null && !contentAlreadyOpen)
                        ) {
                            // goto scene first
                            var route = app.api.PageManager.getRouteFromIDs(
                                item.sceneId
                            );
                            app.api.PageManager.navigateToRoute(route);

                            // open content later to allow auto content (PPE) to load first
                            if (item.contentId) {
                                setTimeout(() => {
                                    app.api.PageManager.openContentComponentFromID(
                                        item.contentId
                                    );
                                }, 2000);
                            }

                            // once redirectet - reminder is used
                            item.useReminder = false;

                            // redirecting overlay
                            let _this = this;
                            setTimeout(() => {
                                _this.isMovingUser = false;
                            }, 2000);
                            this.isMovingUser = true;
                        }
                    }

                    this.nextActivity =
                        i < this.timeTableItems.length
                            ? this.timeTableItems[i + 1]
                            : null;
                } else {
                    item.active = false;

                    // hack to avoid check-in if beyond the first item
                    if (now.isAfter(endTime)) {
                        app.api.LocalDataStore.set("check-in", true);
                    }
                }

                // SHOW REMINDER?
                // IF: not snoozed twice, has useReminder=true, and doesn't link to current scene
                // if (this.snooze <= 1 && item.useReminder && currentSceneID != item.sceneId) {
                if (this.snooze <= 1 && item.useReminder) {
                    let xMinutesBeforeStart =
                        this.snooze == 0
                            ? this.firstReminderMinutesBefore
                            : this.secondReminderMinutesBefore;
                    let differenceInMinutes = startTime.diff(now, "minutes");

                    if (
                        differenceInMinutes > 0 &&
                        differenceInMinutes < xMinutesBeforeStart
                    ) {
                        this.reminderActivity = item;
                        this.showReminder = true;

                        // if page are reloaded below secondAlertTime -> no more snooze
                        if (
                            differenceInMinutes <
                            this.secondReminderMinutesBefore
                        ) {
                            this.snooze = 2;
                        }
                    }
                }
            });

            // before first event starts
            if (now.isBefore(moment(this.timeTableItems[0].startTime))) {
                this.currentActivity = null;
                this.nextActivity = this.timeTableItems[0];
            }
        },

        closeReminder() {
            this.snooze++;
            this.showReminder = false;
        },
    },

    computed: {
        currentActivityString() {
            return `${this.currentActivity.startTimeString} - ${this.currentActivity.endTimeString} : ${this.currentActivity.title}`;
        },
        nextActivityString() {
            return `${this.nextActivity.startTimeString} - ${this.nextActivity.endTimeString} : ${this.nextActivity.title}`;
        },
    },
    beforeDestroy() {
        clearInterval(this.timeCheckInterval);
    },
};
</script>
<style lang="scss" scoped>
#Agenda {
    #AgendaButton {
        position: absolute;
        width: 442px;
        bottom: 10px;
        left: 0px;
        z-index: 2;
        display: flex;
        justify-content: center;

        & > img.bg-now-and-next {
            // position: absolute;
            width: 100%;
            opacity: 0.85;
            transform: translateY(0.2px);
        }

        & > img.bg-button {
            position: absolute;
            width: 230px;
            opacity: 0.85;
            bottom: 58px;
            margin-left: 45px;
        }

        & > .no-event {
            position: absolute;
            color: #fff;
            width: 300px;
            height: 65px;
            margin-top: 13px;
            margin-left: 50px;
        }

        & > .now-and-next {
            position: absolute;
            color: #fff;
            width: 300px;
            height: 65px;
            margin-left: 75px;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;
            cursor: pointer;
            user-select: none;

            & > div {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 25px;
                text-align: left;

                strong,
                b {
                    font-weight: 600 !important;
                }

                &.next {
                    opacity: 0.5;
                }

                span.label {
                    border: 1px solid #fff;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 18px;
                    width: 56px;
                    margin-right: 15px;
                    font-size: 10px;
                    font-weight: bold;
                }

                span.info {
                    width: 180px;
                    display: block;
                    font-size: 15px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            &:hover {
                span.info {
                    // width: calc(100% - 80px) !important;
                    text-overflow: clip;
                    transition: text-indent 10s linear;
                    text-indent: -100%;
                }
            }
        }

        & > button.agenda {
            position: absolute;
            width: 230px;
            height: 50px;
            bottom: 50px;
            margin-left: 45px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                margin-right: 10px;
                font-family: "Arla Strong";
                color: var(--main-color);
            }

            img {
                transition: transform 0.3s;
            }

            &.active {
                img {
                    transform: rotate(180deg);
                }
            }

            &.disabled {
                opacity: 0.2;
                pointer-events: none !important;

                & > * {
                    pointer-events: none !important;
                }
            }
        }
    }

    .timetable-background {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .moving-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        opacity: 0;
        pointer-events: none !important;
        transition: opacity 0.5s;

        font-size: 30px;

        img {
            pointer-events: none !important;
            margin-bottom: 20px;

            @keyframes loading {
                0% {
                    transform: rotate(0);
                }

                100% {
                    transform: rotate(360deg);
                }
            }
        }

        &.active {
            opacity: 1;

            img {
                animation: loading 3s linear infinite;
            }
        }
    }
}
</style>
